import { useEffect, useState } from 'react';
import { GetOrganizationLookup } from '../services/Settings/Organization';

let cache: Record<string, string> | null = null;
let pending: Promise<Record<string, string>> | null = null;

const load = () => {
  if (!pending) {
    pending = GetOrganizationLookup()
      .then((res: any) => {
        const m: Record<string, string> = {};
        (res.data ?? []).forEach((o: any) => {
          m[String(o.organization_id)] = o.organization_code;
        });
        cache = m;
        return m;
      })
      .catch(() => {
        cache = {};
        return cache;
      });
  }
  return pending;
};

export const useOrgCodeMap = () => {
  const [map, setMap] = useState<Record<string, string>>(cache ?? {});
  useEffect(() => {
    let alive = true;
    if (!cache) load().then((m) => alive && setMap(m));
    return () => {
      alive = false;
    };
  }, []);
  return map;
};

export const getSelectedOrgIds = (): number[] => {
  try {
    const multi = localStorage.getItem('selectedOrgIds');
    if (multi) return (JSON.parse(multi) as any[]).map(Number);
    const single = localStorage.getItem('selectedOrgId');
    return single ? [Number(single)] : [];
  } catch {
    return [];
  }
};

export const preloadOrgCodeMap = () => load();
export const getOrgCodeMapSync = (): Record<string, string> => cache ?? {};